import { LOANS } from 'loans.module/common/domain/constants.loans';

class CardSimulationMoreInfoController {
  constructor() {
    this.moreInfoIsVisible = false;
  }

  toggleMoreInfo() {
    this.moreInfoIsVisible = !this.moreInfoIsVisible && this.iconInfoIsVisible;
  }

  haveInsurance() {
    return this.insurance === true;
  }

  isInsuranceDefined() {
    return this.insurance !== undefined;
  }

  isMandatoryInsurance() {
    if (this.loanId === LOANS.ID.SOCIAL_HOUSING_LOAN || this.loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN) {
      return true;
    } else {
      return false;
    }
  }
}

export default CardSimulationMoreInfoController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/requestCardSimulationFamily/cardSimulationMoreInfo/cardSimulationMoreInfo.controller.js